// removed by extract-text-webpack-plugin
module.exports = {"main-text-color":"#1c1b1c"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 929
// module chunks = 0